<template>
  <div
    v-if="activeSlider"
    class="rfp-rr-title-section-177-or review-popup-overlay"
    style="display: block; overflow: auto"
  >
    <div
      v-if="showSuccessPopup"
      ref="popup"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      class="rfp-rr-write-review-success-235-or review-popup full-review-active selectPage-in-drop-down"
      data-popup="review-popup"
      style="display: block"
    >
      <div
        role="button"
        :aria-label="modalCloseButtonAccessibleLabel"
        tabindex="0"
        class="rfp-rr-write-review-success-236-or review-popup-close"
        @keydown.space.prevent
        @keyup.space="closePopup"
        @keydown.enter="closePopup"
        @click="closePopup"
      >
        {{ popupClose }}
      </div>
      <div id="success-message" class="rfp-rr-write-review-success-237-or popup-inner">
        <div
          class="rfp-rr-write-review-success-238-or message-icon success"
          :class="{ 'image--display': successIcon === '' }"
        >
          <img :src="successIcon" :style="{ width: '100%' }" :alt="successIconAltText" />
        </div>
        <div class="rfp-rr-write-review-success-239-or message" v-html="successText"></div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { trapFocus } from '../../../../../shared/utils/dom/focus';

export default {
  name: 'rfp-ratings-write-review-success',
  props: {
    successIcon: {
      type: String,
      required: true,
    },
    successText: {
      type: String,
      required: true,
    },
    successIconAltText: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: 'Close',
    },
  },
  data() {
    return {
      showSuccessPopup: false,
      activeSlider: false,
      deactivateFocusTrap: null,
    };
  },
  watch: {
    async showSuccessPopup(newVal) {
      if (newVal) {
        await this.$nextTick();
        this.deactivateFocusTrap = trapFocus(this.$refs.popup);
      } else {
        this.deactivateFocusTrap();
        this.deactivateFocusTrap = null;
      }
    },
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('showSuccessReview', () => {
      eventBus.emit('ScrollFalse');
      document.body.classList.add('rare-custom-body-class');
      this.activeSlider = true;
      this.showSuccessPopup = true;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.toggle('popup_scroll');
    });
  },
  mounted() {
    document.addEventListener('keydown', this.handleCloseOnEsc);
  },
  unmounted() {
    this.handleUnmounted();
  },
  destroyed() {
    this.handleUnmounted();
  },
  methods: {
    handleUnmounted() {
      document.removeEventListener('keydown', this.handleCloseOnEsc);
    },
    handleCloseOnEsc(event) {
      if (this.showSuccessPopup && event.key === 'Escape') {
        this.closePopup();
      }
    },
    closePopup() {
      this.showSuccessPopup = false;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.remove('popup_scroll');
      document.body.classList.remove('rare-custom-body-class');
      this.activeSlider = false;
      eventBus.emit('ScrollTrue');
    },
  },
};
</script>
